import { UserAnsweredSurveyDTO } from '@higo/api/src/models';
import { flatten } from '@higo/api/src/utils';
import { AxiosInstance } from 'axios';

export const fetchUserAnsweredSurvey = (axios: AxiosInstance) => (id: number) =>
  axios
    .get<UserAnsweredSurveyDTO>(`/api/surveys/users/answers/${id}`)
    .then(flatten);
